import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms'; 
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { ExamService } from 'src/app/services/exam.service';
import { TranslationService } from 'src/app/services/translation.service';
import { FormsSetupService } from 'src/app/services/forms-setup.service';

@Component({
  selector: 'app-exam',
  standalone: true,
  templateUrl: './exam.component.html',
  styleUrl: './exam.component.css',
  imports: [FormsModule, CommonModule] 
})
export class ExamComponent {

  AllExamForms: any[] = [];
  FormNumbers = [1,2,3,4,5,6,7,8,9,10,11,12];

  TraineeName: string = '';
  IDNumber:any;
  Course: any;
  CourseName: string = '';
  FormNumber: any;
  AttemptID: number = 0;
  ExamID: number = 0;
  Language: any;
  LanguageID: number = 0;
  LanguageName: string = '';

  part1: string = '';
  part2: string = '';
  part3: string = '';
  part4: string = '';
  part3Ref: any;
  part4Ref: any;

  ShortName: string = '';
  errorMessage: string = '';
  showAlert: boolean = false;

  languagesList: any[] = [];
  filteredLanguagesList: any[] = [];
  selectedLanguage: any = null;

  nonDisclosureAgreementModal: boolean = false;
  agreeBtn: boolean = false;

  ngOnInit() {
    this.getAllForms();
    this.getLanguages();
  }

  constructor(private router: Router,private formSetup: FormsSetupService, private examService: ExamService, public translationService: TranslationService) {}

  getAllForms() {
    this.formSetup.getAllForms().subscribe((response) => {
      this.AllExamForms = response.result[0];
      this.AllExamForms.forEach((course: any) => {
        const formIDs = course.FormIDs ? course.FormIDs.split(',').map((id: string) => +id.trim()) : [];
        course.FormNumbers = this.FormNumbers.filter((num) => formIDs.includes(num));
      });
    });
  }

  get ExamAttendanceNo(): string {
    return `${this.part1}-${this.part2}-${this.part3}-${this.part4}`;
  }

  autoMove(event: any, nextField: HTMLInputElement) {
    const input = event.target;
    if (input.value.length === input.maxLength) {
      nextField.focus();
    }
  }

  autoBackspace(event: KeyboardEvent, prevField: HTMLInputElement) {
    const input = event.target as HTMLInputElement;
    if (event.key === 'Backspace' && input.value.length === 0) {
      prevField.focus();
    }
  }
  handlePaste(event: ClipboardEvent) {
    const pastedText = (event.clipboardData?.getData('text') || '').trim().replace(/[\r\n]+/g, '');
    const parts = pastedText.split('-');

    if (parts.length === 4) {
      this.part1 = parts[0];
      this.part2 = parts[1];
      this.part3 = parts[2];
      this.part4 = parts[3];

      setTimeout(() => {
        if (this.part2?.length === 4) this.part3Ref?.nativeElement?.focus();
        if (this.part3?.length === 4) this.part4Ref?.nativeElement?.focus();
      });

      event.preventDefault();
    }
  }


  startExam() {
    this.examService.getTraineeDetailsByExamAttendanceNo(this.ExamAttendanceNo, this.LanguageID).subscribe((response) => {
      const traineeData = response.result?.[0]?.[0];
  
      if (!traineeData) {
        this.showErrorMessage('Invalid Exam Attendance Number.');
        return;
      }
  
      if (traineeData.ExamResult == null) {
        this.TraineeName = traineeData.TraineeName;
        this.IDNumber = traineeData.IDNumber;
        this.CourseName = traineeData.CourseName;
        this.Course = this.AllExamForms.find((course) =>
          course.CourseName.toLowerCase().startsWith(this.CourseName.substring(0, 4).toLowerCase())
        );
        this.FormNumber = this.Course.FormNumbers[Math.floor(Math.random() * this.Course.FormNumbers.length)];
  
        if (this.selectedLanguage) {
          this.LanguageID = this.selectedLanguage.LanguageID;
        } else {
          this.LanguageID = this.filteredLanguagesList.find(
            (lang) => lang.LanguageName === traineeData.courseLang
          )?.LanguageID || 0;
        }
  
        this.nonDisclosureAgreementModal = true;
  
      } else if (traineeData.ExamResult === 'In Progress') {
        this.IDNumber = traineeData.IDNumber;
        this.TraineeName = traineeData.TraineeName;
        this.Course = this.AllExamForms.find((course) =>
          course.CourseName.toLowerCase().startsWith(this.CourseName.substring(0, 4).toLowerCase())
        );
  
        this.examService.getExamByAttendanceNo(traineeData.ExamAttendanceNumber).subscribe((response) => {
          const examData = response.result?.[0]?.[0];
          if (examData) {
            this.AttemptID = examData.AttemptID;
            this.ExamID = examData.ExamID;
            this.FormNumber = examData.FormNo;
            this.router.navigate(['dashboard/start-exam']);
          } else {
            this.showErrorMessage('Could not retrieve exam details.');
          }
        });
  
      } else {
        this.showErrorMessage(this.translationService.getTranslation('You have already taken the exam. Plase check your results in Training App'));
      }
    });
  }
  

  getLanguages() {
    this.examService.getLanguageList().subscribe(
      (response) => {
        this.languagesList = response.result[0].map((language: { LanguageName: any; ShortName: any; LanguageID: any }) => ({
          LanguageID : language.LanguageID,
          LanguageName: language.LanguageName,
          ShortName: language.ShortName
        }));

        const desiredLanguages = ["Arabic", "English", "Urdu (Pakistan)", "Bengali (Bangladesh)" , "Hindi (India)" , "Nepali (Nepal)" , "Malayalam" , "Tamil (India)" , "Filipino" , "Indonesian (Indonesia)" , "Turkish (Turkey)"];
        this.filteredLanguagesList = this.languagesList.filter(lang => desiredLanguages.includes(lang.LanguageName));
      },
      () => {
        this.showErrorMessage('Failed to fetch languages. Please try again.');
      }
    );
  }

  onLanguageChange() {
    const selectedLang = this.filteredLanguagesList[this.LanguageID - 1]; 
    this.selectedLanguage = selectedLang;
  }
  
showErrorMessage(message: string) {
  this.errorMessage = message;
  this.showAlert = true;

  setTimeout(() => {
    this.showAlert = false;
    this.errorMessage = '';
  }, 3000);
}

  closeModal(){
    this.nonDisclosureAgreementModal = false;
    this.agreeBtn = true;
  }

  agreeDisclosureAgreement(){
    this.agreeBtn = true

    if(this.nonDisclosureAgreementModal == true && this.agreeBtn == true){
      this.examService.startExam(this.ExamAttendanceNo, this.Course.CourseID, this.FormNumber, this.LanguageID).subscribe((response) => {
        if (response.success = 'true') {
            this.router.navigate(['dashboard/start-exam']);
        } else {
          this.showErrorMessage('Failed to start exam. Please try again.');
        }
      });
    }
  }


}